import React from 'react'
import '../../Work-css/Sub_Icons.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faHashtag, faShop, faSchool, faHouse, faCaretDown, faAddressCard, faAddressBook, faPersonCircleCheck, faSquarePollVertical, faMoneyBill, faComment, faGraduationCap, faPersonMilitaryPointing } from '@fortawesome/free-solid-svg-icons';

function Accomodation_Services({setAcc_Services, setSuluhu, payementgateway, rock, ms, about, client, revs, contacts, school_portal, stude_P, real_estate_portal}) {
  const about_btn = () =>
    {
      about(true)
    }
  
    const clients_btn = () =>
    {
      client(true)
      setAcc_Services(false)
    }
  
    const rev_btn = () =>
    {
      revs(true)
    }
  
    const contacts_btn = () =>
    {
      contacts(true)
    }
  
    const student_PBTN = () =>
    {
        stude_P(true)
    }
  
    const real_EST = () =>
    {
      real_estate_portal(true)
      setAcc_Services(false)
    }
  
    const school_PORT = () =>
    {
      school_portal(true)
    }
  
    const marketing_Space = () =>
    {
      ms(true)
    }
  
    const guidance_CON = () =>
    {
       rock(true)
    }
  
    const payment_GW = () =>
    {
      payementgateway(true)
    }
  
    const suluhu_PBTN = () =>
    {
      setSuluhu(true)
    }
  return (
    <div className='Sub_main'>
     <p className='sub_TT'>Accomodation Services</p>
     <div>

            <div className='button_DIV'><FontAwesomeIcon icon={faPersonCircleCheck} className='icon_part' /><button onClick={clients_btn}>Client Reviews</button></div>
          <div className='button_DIV'><FontAwesomeIcon icon={faHouse} className='icon_part' /><button onClick={real_EST}>Real Estate Portal</button></div>
          
                  
                

     </div>
    </div>
  )
}

export default Accomodation_Services
